<template>
    <div>
        <breadcrumbs
                :title="'Dodatni sadržaji'"
                :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox ">
            <div class="ibox-title">
                    <h5>Dodatni sadržaji</h5><br>
                <button
                        type="button"
                        class="btn btn-lg btn-primary"
                        @click.prevent="create"
                >
                    Novi unos
                </button>
            </div>
            <div class="ibox-content">
                <datatables
                        v-if="show_datatable"
                        :url="datatables_url"
                        :settings="datatables.settings"
                        :title="datatables.title"
                        @rowClick="rowClick"
                >
                </datatables>
            </div>
        </div>
    </div>

</template>

<script>
import Datatables from "@/components/datatable/Datatables";
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";
export default {
name: "DodatniSadrzaji",
    components: {Breadcrumbs, Datatables},
    data(){
        return {
            show_datatable : false,
            datatables_url: process.env.VUE_APP_API_URL + 'dodatni-sadrzaj',
            datatables: {},
            breadcrumbs: [],
        }
    },

    methods:{
        rowClick( row ){
            this.$router.push( { path: '/postavke/dodatni-sadrzaji/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/postavke/dodatni-sadrzaji/create' } )
        },

        setDatatable(){
            let vm = this;
            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,


                        },
                        {
                            'id': 'naziv',
                            'title': 'Naziv',
                            'column_visibility_group': {
                                id: 'dodatni_sadrzaj',
                                visible: true
                            }
                        },
                        {
                            'id': 'opis',
                            'title': 'Opis',
                            'column_visibility_group': {
                                id: 'dodatni_sadrzaj',
                            }
                        }
                    ],
                            column_visibility_groups:{
                        'dodatni_sadrzaj' : 'Dodatni sadržaj'
                    },
                    order: 'desc',
                            order_by: 'id',
                },
                title: 'Dodatni sadržaj',
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/dodatni-sadrzaji',
                    name: 'Administratori'
                }
            ];
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>